import { hot } from 'react-hot-loader/root';
import React, { Component } from 'react';
import './public/styles/main.scss';
import TagManager from 'react-gtm-module';
import { ToastContainer } from 'react-toastify';
import RoutesContainer from './routes';
import { handleKettoLinks } from '../services/helperFunctions';
import { UserLogin } from '../contexts/LoggedInUserContext';
import 'react-toastify/dist/ReactToastify.css';

require('./public/styles/main.scss');

const tagManagerArgs = {
  gtmId: process.env.NODE_ENV == 'development' ? 'GTM-TTCPZXV' : 'GTM-5224QDW', // add gtm by env
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidUser: false,
      isLoading: false,
    };
  }

  componentDidMount() {
    TagManager.initialize(tagManagerArgs);
  }

  handleInvalidRoute = () => {
    window.location.href = handleKettoLinks('new/404');
  }

  render() {
    const {
      isValidUser, isLoading,
    } = this.state;

    return (
      <>
        <UserLogin>
          <ToastContainer hideProgressBar position="bottom-right" />
          {!isLoading && <RoutesContainer isValidUser={isValidUser} />}
        </UserLogin>
      </>
    );
  }
}

export default hot(App);
